/**
 * Avoid lagging when switching icon via state
 */
interface FlipIconProps {
  activeIcon: React.ReactNode;
  inactiveIcon: React.ReactNode;
  isActive: boolean;
}

export function FlipIcon({
  activeIcon,
  inactiveIcon,
  isActive,
}: FlipIconProps) {
  return (
    <span>
      <span style={{ display: isActive ? "inline-block" : "none" }}>
        {activeIcon}
      </span>
      <span style={{ display: !isActive ? "inline-block" : "none" }}>
        {inactiveIcon}
      </span>
    </span>
  );
}
